import { Component, OnInit } from '@angular/core';
// Forms
import { FormGroupDirective, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-insurance-details',
  templateUrl: './insurance-details.component.html',
  styleUrls: ['./insurance-details.component.scss'],
})

export class InsuranceDetailsComponent  implements OnInit {

  /**
   * Variables
   */
  VehicleForm: FormGroup;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private alertController: AlertController
  ) { }

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the vehicle form.
   */
  ngOnInit() {
    this.VehicleForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

    // #region --> Date Methods

  /**
   * This method is used when an expiration date is introduced and checks if the format is correct.
   * @param ev : expiration date introduced
   */
  async expirationDateChange(ev: any) {
    const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;//Regex in order to detect if the string input is a valid date format

    if (!pattern.test(ev.detail.value)) {
      const alert = await this.alertController.create({
        header: 'Invalid date',
        message:
          'Please, enter a date with the format DD/MM/YYYY like 12/11/2021. Also check if the date you have entered exists.',
        buttons: [
          {
            text: 'OK',
            handler: async () => {
              this.VehicleForm.get('insuranceDetails')?.get('expirationDate')?.patchValue('');
              await alert.dismiss(); // ✅ dismiss THIS alert
              return false;          // optional: prevents any weird default behavior
            },
          },
        ],
        backdropDismiss: false, // optional: user can't click outside to close
      });

      await alert.present();
    }
  }
  // #endregion --> Date Methods

}
